<template>
  <div class="message-input-wrapper">
    <MessageInputQuote 
      @getQuoteMessageCloudCustomData="getQuoteMessageCloudCustomData"
    />
    <div
      :class="[
        'message-input-container',
        !isPC && 'message-input-container-h5',
      ]"
    >
      <div v-if="shouldShowAudio" class="audio-icon" @click="audioShow">
        <Icon :file="isInAudioMode ? keyboardIcon : audioIcon" width="24px" height="24px"/>
      </div>
      <MessageInputEditor
        ref="editor"
        :placeholder="placeholder"
        :isMuted="props.isMuted"
        :muteText="props.muteText"
        :enableInput="props.enableInput"
        :enableTyping="props.enableTyping"
        :enableDragUpload="props.enableDragUpload"
        :isInAudioModeFromProps="isInAudioMode"
        :shouldShowToolbar="shouldShowToolbar"
        :shouldShowEmoji="shouldShowEmoji"
        :shouldShowAudio="shouldShowAudio"
        @sendMessage="sendMessage"
        @onTyping="onTyping"
        @blurToolAndEmojiH5="blurToolAndEmojiH5"
        @isInputNotEmpty="isInputNotEmpty"
      />
      <MessageInputButton
        v-if="!props.isMuted && isPC"
        @sendMessage="sendMessage"
      />
      <div v-if="isH5 && shouldShowEmoji" :class="['emoji-icon',!shouldShowToolbar && isH5 ? 'emoji-h5-no-toolbar' : '']" id="emoji-icon-h5" @click="emojiShow">
        <Icon :file="emojiIcon" width="24px" height="24px"/>
      </div>
      <div v-show="isH5 && shouldShowToolbar && !showSendButton" class="tool-icon" @click="toolShow">
        <Icon :file="toolIcon" width="24px" height="24px"/>
      </div>
      <div v-show="isH5 && showSendButton" class="send-button-h5" @click="sendMessage">
        <Icon :file="sendButtonIcon" width="34px" height="34px"/>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { TUIStore, StoreName, IConversationModel, TUITranslateService } from '../../../@aidesk/uikit-engine';
import vue from '../../../adapter-vue';
import MessageInputEditor from './message-input-editor-web.vue';
import MessageInputButton from './message-input-button.vue';
import MessageInputQuote from './message-input-quote/index.vue';
import { sendMessages, sendTyping } from '../utils/sendMessage';
import { transformTextWithEmojiNamesToKeys } from '../emoji-config';
import { isPC, isH5 } from '../../../utils/env';
import Icon from '../../common/Icon.vue';
import emojiIcon from '../../../assets/emoji.png';
import toolIcon from '../../../assets/more_tools.png';
import sendButtonIcon from '../../../assets/send_button_h5.svg';
import audioIcon from '../../../assets/audio-blue.svg';
import keyboardIcon from '../../../assets/keyboard-icon.svg';
import { INPUT_TOOLBAR_TYPE } from '../../../constant';
import Log from '../../../utils/logger';
import { Toast, TOAST_TYPE } from '../../common/Toast/index-web';
const __sfc_main = {};
__sfc_main.props = {
  isMuted: {
    type: Boolean,
    default: true
  },
  muteText: {
    type: String,
    default: ''
  },
  enableInput: {
    type: Boolean,
    default: true
  },
  enableDragUpload: {
    type: Boolean,
    default: true
  },
  enableTyping: {
    type: Boolean,
    default: true
  },
  inputToolbarList: {
    type: Array,
    default: undefined
  },
  enableSendingAudio: {
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref,
    onMounted,
    onBeforeUnmount,
    computed,
    onUnmounted
  } = vue;
  const props = __props;
  const emit = __ctx.emit;
  const placeholder = ref(TUITranslateService.t('TUIChat.请输入消息'));
  const editor = ref<InstanceType<typeof MessageInputEditor>>();
  const currentConversation = ref<IConversationModel>();
  const h5Dialog = ref<HTMLElement>();
  const showSendButton = ref(false);
  const isInHumanService = ref(false);
  let quoteMessageCloudCustomData: string = '';
  const isInAudioMode = ref(false);
  const isInEmojiMode = ref(false);
  let hasAudioStream = false;
  let audioStream = null;
  onMounted(() => {
    // document.addEventListener('click', handleClick);
    TUIStore.watch(StoreName.CUSTOM, {
      isInHumanService: onInHumanServiceUpdate
    });
    document.addEventListener('visibilitychange', handleVisibilityChange);
  });
  onUnmounted(() => {
    TUIStore.unwatch(StoreName.CUSTOM, {
      isInHumanService: onInHumanServiceUpdate
    });
    stopAudioStream();
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });
  const onInHumanServiceUpdate = (data: {
    conversationID: string;
    value: boolean;
  }) => {
    if (data && data.conversationID === currentConversation.value.conversationID) {
      isInHumanService.value = data.value;
      if (!isInHumanService.value) {
        isInAudioMode.value = false;
        placeholder.value = TUITranslateService.t('TUIChat.请输入消息');
        stopAudioStream();
      }
    }
  };
  onBeforeUnmount(() => {
    // document.removeEventListener('click', handleClick);
  });
  function handleClick(e: any) {
    var div = document.getElementById('emoji-icon-h5'); // 替换为你的 div 元素的 ID
    var targetElement = e.target;
    if (div != null && targetElement != null && !div.contains(targetElement instanceof Node ? targetElement : null)) {
      // 在这里执行你想要触发的函数
      emit('blurToolAndEmojiH5');
    }
  }
  TUIStore.watch(StoreName.CONV, {
    currentConversation: (conversation: IConversationModel) => {
      currentConversation.value = conversation;
    }
  });
  const onTyping = (inputContentEmpty: boolean, inputBlur: boolean) => {
    sendTyping(inputContentEmpty, inputBlur);
  };
  const sendMessage = async () => {
    const _editorContentList = editor.value?.getEditorContent();
    if (!_editorContentList || !currentConversation.value) return;
    let hasValidContent = false;
    const editorContentList = _editorContentList.map((editor: any) => {
      if (editor.type === 'text') {
        editor.payload.text = transformTextWithEmojiNamesToKeys(editor.payload.text);
        const isEmptyText = !editor.payload.text || editor.payload.text.trim() === '';
        if (!isEmptyText) {
          hasValidContent = true;
        }
        return !isEmptyText ? editor : undefined;
      }
      hasValidContent = true;
      return editor;
    }).filter(Boolean);
    if (!hasValidContent) {
      editor.value?.resetEditor();
      Toast({
        message: TUITranslateService.t('AIDesk.不能发送空白消息'),
        type: TOAST_TYPE.ERROR,
        duration: 3000
      });
      return;
    }
    await sendMessages(editorContentList, currentConversation.value, quoteMessageCloudCustomData);
    // 注意这里不要 emit 'sendMessage'，避免写出死循环
    emit('messageSent');
    editor.value?.resetEditor();
    if (!isInEmojiMode.value && !isInAudioMode.value) {
      editor.value?.focusEditor();
    }
    showSendButton.value = false;
  };
  const getQuoteMessageCloudCustomData = (cloudCustomData: string) => {
    quoteMessageCloudCustomData = cloudCustomData;
  };
  const insertEmoji = (emoji: any) => {
    editor.value?.addEmoji(emoji);
    showSendButton.value = true;
  };
  const reEdit = (content: any) => {
    editor.value?.resetEditor();
    showSendButton.value = false;
    editor.value?.setEditorContent(content);
  };
  const isInputNotEmpty = (show: boolean) => {
    showSendButton.value = show;
  };
  const emojiShow = () => {
    emit('emojiShow');
    isInEmojiMode.value = !isInEmojiMode.value;
    isInAudioMode.value = false;
  };
  const toolShow = () => {
    emit('toolShow');
    isInEmojiMode.value = false;
    isInAudioMode.value = false;
  };
  const blurToolAndEmojiH5 = () => {
    emit('blurToolAndEmojiH5');
    isInEmojiMode.value = false;
  };
  const getAudioStream = async () => {
    try {
      stopAudioStream();
      audioStream = await navigator.mediaDevices.getUserMedia({
        audio: true
      });
      hasAudioStream = true;
    } catch (err) {
      Log.e('Error accessing audio stream:', err);
    }
  };
  const stopAudioStream = () => {
    if (audioStream) {
      audioStream.getTracks().forEach(track => track.stop());
      audioStream = null;
      hasAudioStream = false;
    }
  };
  const audioShow = () => {
    isInAudioMode.value = !isInAudioMode.value;
    if (isInAudioMode.value && !hasAudioStream) {
      getAudioStream();
    }
    placeholder.value = isInAudioMode.value ? TUITranslateService.t('TUIChat.按住说话') : TUITranslateService.t('TUIChat.请输入消息');
    emit('blurToolAndEmojiH5');
  };
  const shouldShowToolbar = computed(() => {
    if (props.inputToolbarList !== undefined && props.inputToolbarList.length === 0) {
      return false;
    }
    if (props.inputToolbarList !== undefined && props.inputToolbarList.length === 1 && (props.inputToolbarList[0]?.presetId === INPUT_TOOLBAR_TYPE.EMOJI || props.inputToolbarList[0]?.presetId === INPUT_TOOLBAR_TYPE.AUDIO)) {
      return false;
    }
    return true;
  });
  const shouldShowEmoji = computed(() => {
    return (props.inputToolbarList === undefined || props.inputToolbarList.some(item => item.presetId === INPUT_TOOLBAR_TYPE.EMOJI && item.isEnabled === 1)) && !isInAudioMode.value;
  });
  const shouldShowAudio = computed(() => {
    return isH5 && isInHumanService.value && (props.enableSendingAudio === 1 || props.inputToolbarList !== undefined && props.inputToolbarList.some(item => item.presetId === INPUT_TOOLBAR_TYPE.AUDIO && item.isEnabled === 1));
  });
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      stopAudioStream();
    } else if (document.visibilityState === 'visible' && isInAudioMode.value) {
      getAudioStream();
    }
  };
  return Object.assign({
    isPC,
    isH5,
    emojiIcon,
    toolIcon,
    sendButtonIcon,
    audioIcon,
    keyboardIcon,
    props,
    placeholder,
    editor,
    showSendButton,
    isInAudioMode,
    onTyping,
    sendMessage,
    getQuoteMessageCloudCustomData,
    isInputNotEmpty,
    emojiShow,
    toolShow,
    blurToolAndEmojiH5,
    audioShow,
    shouldShowToolbar,
    shouldShowEmoji,
    shouldShowAudio
  }, {
    insertEmoji,
    reEdit,
    sendMessage
  });
};
__sfc_main.components = Object.assign({
  MessageInputQuote,
  Icon,
  MessageInputEditor,
  MessageInputButton
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped lang="scss">
@import "../style/common";

.message-input-wrapper {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.message-input-container {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  border: none;
  overflow: hidden;
}

.message-input-container-h5 {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
}
.emoji-icon {
  background: #fff;
  border-radius: 0 10px 10px 0;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}

.emoji-h5-no-toolbar {
  margin-right: 10px;
}

.tool-icon {
  background: #fff;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.audio-icon {
  background: #fff;
  margin-left: 10px;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-tool-dialog{
  height: fit-content;
    background: #fff;
}
.send-button-h5 {
  margin-right: 10px;
  margin-left: 5px;
}
</style>
